export default __webpack_public_path__ + "images/c2e6fde37adf02df12528fbe0a7648e3-lamp.png";